import React, { ChangeEvent } from "react";
import styled from "@emotion/styled";
import { colors } from "src/theme";
import { MergeWithOverwrite } from "src/common";
import { InputLabel } from "../typography";

const Input = styled.input((props: { hasError: boolean }) => ({
  boxSizing: 'border-box' as const,
  outline: 'none',
  display: 'block',
  width: '100%',
  height: '44px',
  padding: '9px 12px',
  fontSize: '18px',
  fontWeight: 400,
  fontFamily: "Red Hat Display",
  fontStyle: 'normal',
  lineHeight: '24px',
  color: colors.text1,
  backgroundColor: 'transparent',
  borderRadius: '8px',
  border: `1px solid ${props.hasError ? colors.error1 : colors.border5}`,
  transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',

  '&[disabled]': {
    border: `1px solid ${colors.border6}`,
    color: colors.text4,
    pointerEvents: 'none' as const,
  },

  '&::-moz-placeholder': {
    color: colors.text4,
    opacity: 1,
  },

  '&:-ms-input-placeholder': {
    color: colors.text4,
  },

  '&::-webkit-input-placeholder': {
    color: colors.text4,
  },

  '&:focus::-moz-placeholder': {
    color: 'transparent',
    opacity: 1,
  },

  '&:focus:-ms-input-placeholder': {
    color: 'transparent',
  },

  '&:focus::-webkit-input-placeholder': {
    color: 'transparent',
  },

  '&:focus': {
    borderColor: colors.border4,
  },

  '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none' as const,
    MozAppearance: 'none' as const,
    appearance: 'none' as const,
  },
}));

const ValidationError = styled.div({
  position: 'absolute',
  color: colors.error1,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '1.14',
  marginBottom: 0,
  paddingTop: '4px',
  transition: 'all 0.4s ease',
});

export type InputDateOfBirthProps = MergeWithOverwrite<React.InputHTMLAttributes<HTMLInputElement>, {
  label?: string;
  error?: string;
  onChange?: (value: string) => void;
}
>;

export const InputDateOfBirth: React.FC<InputDateOfBirthProps> = ({
  label,
  error,
  onChange,
  ...props
}) => {

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e.target.value);
  };

  return (
    <div>
      {label ? <InputLabel htmlFor={props.id} disabled={props.disabled}>{label}</InputLabel> : null}
      <Input
        autoComplete="off"
        {...props}
        type='date'
        id={props.id}
        onChange={handleChange}
        hasError={!!error}
      />
      {error ? <ValidationError>{error}</ValidationError> : null}
    </div>
  );
};